import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import {
  caretAltLeftIcon,
  caretAltRightIcon,
  caretAltToLeftIcon,
  caretAltToRightIcon,
  SVGIcon
} from '@progress/kendo-svg-icons';

type PagerEdge = 'first' | 'prev' | 'next' | 'last';

@Component({
  selector: 'app-keyset-paging-pager-buttons',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonsModule, GridModule],
  templateUrl: './keyset-paging-pager-buttons.component.html',
  styleUrls: ['./keyset-paging-pager-buttons.component.scss']
})
export class KeysetPagingPagerButtonsComponent
{
  @Input() public loading = false;
  @Input() public hasPrevious = false;
  @Input() public hasMore = false;
  @Input() public pageSizes: number[] | null = null;

  @Output() public readonly first = new EventEmitter<void>();
  @Output() public readonly prev = new EventEmitter<void>();
  @Output() public readonly next = new EventEmitter<void>();
  @Output() public readonly last = new EventEmitter<void>();

  protected readonly actions: ReadonlyArray<{
    id: PagerEdge;
    navClass: string;
    fontIcon: string;
    svgIcon: SVGIcon;
    titleKey: string;
    disabledWhen: 'back' | 'forward';
  }> = [
    {
      id: 'first',
      navClass: 'k-pager-nav k-pager-first',
      fontIcon: 'caret-alt-to-left',
      svgIcon: caretAltToLeftIcon,
      titleKey: 'PAGER-FIRST',
      disabledWhen: 'back'
    },
    {
      id: 'prev',
      navClass: 'k-pager-nav',
      fontIcon: 'caret-alt-left',
      svgIcon: caretAltLeftIcon,
      titleKey: 'PAGER-PREV',
      disabledWhen: 'back'
    },
    {
      id: 'next',
      navClass: 'k-pager-nav',
      fontIcon: 'caret-alt-right',
      svgIcon: caretAltRightIcon,
      titleKey: 'PAGER-NEXT',
      disabledWhen: 'forward'
    },
    {
      id: 'last',
      navClass: 'k-pager-nav k-pager-last',
      fontIcon: 'caret-alt-to-right',
      svgIcon: caretAltToRightIcon,
      titleKey: 'PAGER-LAST',
      disabledWhen: 'forward'
    }
  ];

  protected buttonDisabled(edge: typeof this.actions[number]): boolean
  {
    const back = edge.disabledWhen === 'back';
    return this.loading ||
      (back ? !this.hasPrevious : !this.hasMore);
  }

  protected onAction(id: PagerEdge): void
  {
    if (id === 'first')
    {
      this.first.emit();
    }
    else if (id === 'prev')
    {
      this.prev.emit();
    }
    else if (id === 'next')
    {
      this.next.emit();
    }
    else
    {
      this.last.emit();
    }
  }
}
